import React from "react";
import { css } from "@linaria/core";
import t from "../../../../../../../i18n";
import ButtonIconV2 from "@ui/ButtonIconV2";
import { ArrowDownLine, ArrowUpLine } from "@ui/IconV2/react";
import { colors, spacings } from "@ui/Theme";
import TooltipV2 from "@ui/TooltipV2";
import { Text } from "@ui/Text";
import { useSwapBlockCallback } from "../../../../hook/action/swap_block";
import type { DashboardBlockModelT } from "../../../../schema/dashboard";

export function BlockPosition<T extends DashboardBlockModelT | undefined>({ block }: { block: T }) {
  const { siblingBlock: previousSiblingBlock, swapBlock: swapPreviousBlock } = useSwapBlockCallback(
    block,
    "up",
  );

  const { siblingBlock: nextSiblingBlock, swapBlock: swapNextBlock } = useSwapBlockCallback(
    block,
    "down",
  );

  return (
    <div className={blockPositioning}>
      <Text>{t("project.dashboard.editor.gui.position")}</Text>
      <TooltipV2 overlay={t("tooltip.editor.plot.move_up")}>
        <ButtonIconV2 onClick={() => swapPreviousBlock()} disabled={!previousSiblingBlock}>
          <ArrowUpLine />
        </ButtonIconV2>
      </TooltipV2>
      <Text as="span">{block?.position[1]}</Text>
      <TooltipV2 overlay={t("tooltip.editor.plot.move_down")}>
        <ButtonIconV2 onClick={() => swapNextBlock()} disabled={!nextSiblingBlock}>
          <ArrowDownLine />
        </ButtonIconV2>
      </TooltipV2>
    </div>
  );
}

const blockPositioning = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
  color: ${colors.carbon800};
  margin-bottom: 16px;
`;
